

// Localização: frontend/src/components/Navigation/HeaderPublic.jsx (versão 0.0.6 - Logo Ícone Isolado)
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

// 🎯 ATUALIZAÇÃO CRÍTICA: Troque para o caminho da sua NOVA IMAGEM do ícone isolado.
// Se você for usar a Gemini_Generated_Image_zazz36zazz36zazz.jpg (o escudo sozinho),
// que já é um ícone limpo, mantenha-a. Se for uma nova que você editou, atualize o caminho.
const LOGO_PATH = '/images/higeia-icon-only.png'; // Exemplo: Nova imagem editada

const navItems = [
    { name: 'Nossa História', href: '/sobre-nos' },
    { name: 'Recursos', href: '/recursos' },
    { name: 'Planos', href: '/pricing' },
    { name: 'Ponto Digital', href: '/planos/registro-de-ponto' },
    { name: 'Demonstração', href: '/demonstracao' },
];

const HeaderPublic = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <header className="relative z-50 bg-white"> 
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="flex items-center h-20 gap-4">
                    
                    {/* Logo - Agora será apenas o ícone */}
                    <div className="flex flex-1 items-center min-w-0">
                        <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
                            <img 
                                className="h-12 w-auto"
                                src={LOGO_PATH} 
                                alt="Higeia.tech Icon"
                            />
                            <span className="ml-3 text-xl font-bold text-higeia-dark hidden sm:block">Higeia.tech</span>
                        </Link>
                    </div>

                    {/* Links de Navegação (Desktop) */}
                    <nav className="hidden lg:flex lg:gap-x-10 text-lg">
                        {navItems.map((item) => (
                            item.href.startsWith('/') ? (
                                <Link
                                    key={item.name}
                                    to={item.href}
                                    className="text-gray-900 hover:text-higeia-dark font-medium transition duration-150"
                                >
                                    {item.name}
                                </Link>
                            ) : (
                                <a 
                                    key={item.name} 
                                    href={item.href} 
                                    className="text-gray-900 hover:text-higeia-dark font-medium transition duration-150"
                                >
                                    {item.name}
                                </a>
                            )
                        ))}
                    </nav>

                    <div className="flex flex-1 items-center justify-end relative">
                        {/* Menu Mobile Button */}
                        <button 
                            type="button" 
                            onClick={toggleMobileMenu}
                            className="lg:hidden p-2 text-gray-900 hover:text-higeia-dark transition duration-150"
                            aria-label="Toggle mobile menu"
                        >
                            {isMobileMenuOpen ? (
                                <X className="h-6 w-6" />
                            ) : (
                                <Menu className="h-6 w-6" />
                            )}
                        </button>

                        {/* Menu Mobile Dropdown - Card Flutuante */}
                        {isMobileMenuOpen && (
                            <div className="lg:hidden absolute top-full right-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-200 z-[60] overflow-hidden">
                                <nav className="py-2">
                                    {navItems.map((item) => (
                                        item.href.startsWith('/') ? (
                                            <Link
                                                key={item.name}
                                                to={item.href}
                                                onClick={closeMobileMenu}
                                                className="block px-4 py-3 text-base font-medium text-gray-900 hover:text-higeia-dark hover:bg-gray-50 transition duration-150"
                                            >
                                                {item.name}
                                            </Link>
                                        ) : (
                                            <a 
                                                key={item.name} 
                                                href={item.href}
                                                onClick={closeMobileMenu}
                                                className="block px-4 py-3 text-base font-medium text-gray-900 hover:text-higeia-dark hover:bg-gray-50 transition duration-150"
                                            >
                                                {item.name}
                                            </a>
                                        )
                                    ))}
                                </nav>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderPublic;